import { TranslateService } from '@ngx-translate/core';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfigService} from '../shared/service/config.service';
import {ConfigModel} from '../shared/model/config.model';
import {EvaluetionFormModalComponent} from './evaluetion-form-modal/evaluetion-form-modal.component';
import {MessageComponent} from '../shared/component/message/message.component';

@Component({
    selector: 'app-config',
    templateUrl: './config.component.html',
    styleUrls: ['./config.component.css']
})
export class ConfigComponent implements OnInit {
    @ViewChild(EvaluetionFormModalComponent) evaluetionFormModal: EvaluetionFormModalComponent;
    @ViewChild(MessageComponent) message: MessageComponent;

    apiVersion: string = 'v2';
    validateSave: boolean = true;

    configList: ConfigModel[];
    config: ConfigModel = new ConfigModel();

    constructor(
		private translateService: TranslateService,
        private configService: ConfigService,
    ) {
    }

    translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

    ngOnInit() {
        this.getItens();
        this.getVersion();
    }

    getItens() {
        this.configService.getAll().subscribe(r => {
            this.configList = r as ConfigModel[];
        });
    }

    getVersion() {
        this.configService.getVersion().subscribe(r => {
            this.apiVersion = r && r.version || 'v2';
        });
    }

    onSelect(e) {
        this.config = e.data as ConfigModel;
        this.validateSave = true;
        if (this.config.type === "evaluation_weight") {
            this.validateSave = false;
        }
    }

    onSave() {
        this.configService.save(this.config).subscribe(r => {
            this.message.success(r.message);
            this.getItens();
        });
    }

    onDelete() {
        this.configService.delete(this.config.id).subscribe(r => {
            this.message.success(r.message);
        })
    }

    validate() {
        return this.validateSave;
    }

    openEvaluetionWeight() {
        if (this.config !== undefined) {
            this.evaluetionFormModal.evaluetion = this.config;
            this.evaluetionFormModal.display = true;
        }

    }

    saveEvaluetion($event) {
        this.config.value = $event.value;

        this.onSave();

        this.evaluetionFormModal.display = false;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/config/config.component.ts